import { useEffect, useState } from "react";
import { P, pub } from "@/lib/publicApi";

const Stat = ({ label, value, color, testid }) => (
  <div data-testid={testid} className="p-4 rounded-sm border bg-white" style={{ borderColor: P.line }}>
    <div className="text-3xl font-bold font-mono" style={{ color: color || P.navy }}>{value ?? "—"}</div>
    <div className="text-[10px] uppercase tracking-wider mt-1 font-bold" style={{ color: P.dim }}>{label}</div>
  </div>
);

export default function Accountability() {
  const [s, setS] = useState(null);
  useEffect(() => { pub.get("/stats").then((r) => setS(r.data)).catch(() => {}); }, []);
  return (
    <div className="max-w-4xl mx-auto space-y-6">
      <div>
        <h2 className="text-2xl font-bold" style={{ color: P.navy }}>Public Accountability Dashboard — {s?.year || ""}</h2>
        <p className="text-sm mt-1" style={{ color: P.dim }}>Aggregate complaint, commendation and calls-for-service statistics. {s?.note}</p>
      </div>
      {s && (
        <>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
            <Stat testid="stat-complaints-received" label="Complaints Received" value={s.complaints.received} />
            <Stat testid="stat-complaints-closed" label="Closed" value={s.complaints.closed} color={P.green} />
            <Stat testid="stat-complaints-pending" label="Pending" value={s.complaints.pending} color={P.gold} />
            <Stat testid="stat-commendations" label="Commendations" value={s.commendations} color={P.green} />
          </div>
          <div className="p-4 rounded-sm border bg-white" style={{ borderColor: P.line }}>
            <div className="text-[10px] uppercase tracking-wider font-bold mb-3" style={{ color: P.dim }}>Allegation Findings</div>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
              {Object.keys(s.findings).length === 0 && <div className="text-sm col-span-4" style={{ color: P.dim }}>No completed investigations published yet.</div>}
              {Object.entries(s.findings).map(([k, v]) => (
                <div key={k}><div className="font-mono text-xl font-bold" style={{ color: P.navy }}>{v}</div><div className="text-xs" style={{ color: P.dim }}>{k}</div></div>
              ))}
            </div>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
            <Stat testid="stat-resolution" label="Avg Resolution (Days)" value={s.average_resolution_days ?? "—"} />
            <Stat label="Police Calls" value={s.calls_for_service.police} />
            <Stat label="Fire Calls" value={s.calls_for_service.fire} color="#B3261E" />
            <Stat label="EMS Calls" value={s.calls_for_service.ems} color={P.green} />
          </div>
        </>
      )}
    </div>
  );
}
